import { Getter } from "../types";

export default {};
